import React, { useState, useEffect, useContext } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import UserContext from '../../context/UserContext';
import { toast } from 'react-toastify';

const EditCustomer = () => {
  const { id } = useParams(); // Get customer ID from URL
  const [customer, setCustomer] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true); 
    const [reset, setReset] = useState(true); 
    const [originalCustomer, setoriginalCustomer] = useState(true); 
  const { userInfo, customers, salesreps, csrreps, apiURL } = useContext(UserContext);
  const nav = useNavigate();
  const [newpass, setNewpass] = useState(null); 
  //console.log(customer);
  useEffect(() => {
    if (userInfo?.level === '0') {
      nav('/dashboard');
    }
    if (userInfo?.level === '9' || userInfo?.level === '8' || userInfo?.level === '7') {
      setDisabled(false);
    }
  }, [userInfo]);

  //console.log(id);
  // Fetch customer data on component mount
  useEffect(() => {
    //console.log(id);
    const fetchCustomer = async () => {
      try {
        const response = await axios.post(`${apiURL}/users/getuser`, { id: id });
        //console.log(response.data);
         setoriginalCustomer(response.data.message[0]);
        setCustomer(response.data.message[0]);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchCustomer();
  }, [reset]);



     //console.log(originalCustomer?.active);
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    let cust = {
      id: customer?._id,
      name: customer?.name,
      email: customer?.email,
      level: customer?.level,
      address: customer?.address,
      phone: customer?.phone,
      active: customer?.active,
      company: customer?.company,
      salesrep: customer?.salesrep,
      csrrep: customer?.csrrep,
      sendEmail: originalCustomer?.active === "false" && customer?.active === "true" // Flag to send email if active changes from false to true

    };

    try {
   await axios.post(`${apiURL}/users/updateuser`, cust)
   .then(res => {
    if(res.data.status === 200){
       toast.success('Customer updated successfully!');
      setReset(!reset)
    }
   })
   .catch(err => console.log(err))
     
    } catch (err) {
      setError('Failed to update customer');
    }
  };



  const changecsr = (e) => {
    let tempcsr = csrreps.filter(filt => filt._id === e.target.value);
    //console.log(tempcsr[0]);
    let csr = {
      name: tempcsr[0]?.firstName + ' ' + tempcsr[0]?.lastName.substr(0, 1),
      id: tempcsr[0]?._id,
      email: tempcsr[0]?.workEmail
    };
    setCustomer({ ...customer, csrrep: csr });
  };

  const changesales = (e) => {
    let tempsales = salesreps.filter(filt => filt._id === e.target.value);
    //console.log(tempsales[0]);
    let sales = {
      name: tempsales[0]?.firstName + ' ' + tempsales[0]?.lastName.substr(0, 1),
      id: tempsales[0]?._id,
      email: tempsales[0]?.workEmail
    };
    setCustomer({ ...customer, salesrep: sales });
  };

  const changepassword = () => {
if(!newpass || newpass === ''){
 toast.warning('Password can not be empty')
 return
}
if(newpass.length <= 7){
 toast.warning('Password must be 7 characters or longer')
  return
}
let payload = {id,pass:newpass}
console.log(payload)
  }


  //console.log(salesreps);
  //console.log(customer);

  if (loading) return <div className="text-center mt-8">Loading...</div>;
  if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;
  console.log(customer);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="w-full py-[20px] px-[25px]">
          <div className='flex p-[20px] border-b-1'>
            <div className="flex-3 text-left flex items-center justify-start">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-left">{customer?.name}</h2>
            </div>
            <div className="flex-1" style={{ textAlign: 'right' }}>
              <button
                type="button"
                className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                onClick={e => nav('/dashboard')}
              >
                Go to Dashboard
              </button>
            </div>
          </div>
          {customer?.level === '0' && (
            <div className='flex relative mt-[15px]'>
              <div className="flex-1 relative">
                <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                  Company
                </label>
                {userInfo?.level === '9' ? (
                  <>
                    <input
                      defaultValue={customer?.company}
                      id="customerInput"
                      list="customers"
                      type="text"
                      className="max-w-[80%] mt-3 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="Select or type a company name"
                      onBlur={e => setCustomer({ ...customer, company: e.target.value })}
                      disabled={disabled}
                    />
                    <datalist id="customers">
                      {customers.map((cust) => (
                        <option key={cust?._id} value={cust?.name} />
                      ))}
                    </datalist>
                  </>
                ) : (
                  <div className='text-left'>{customer?.company || "Unknown"}</div>
                )}
              </div>
              <div className="flex-1 relative">
                <label htmlFor="salesrep" className="block text-left text-sm font-medium text-gray-700">
                  Sales Rep
                </label>
                {userInfo?.level === '9' ? (
                  <select
                    onChange={e => changesales(e)}
                    value={customer?.salesrep?.id}
                    className="max-w-[80%] mt-3 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    disabled={disabled}
                  >
                    <option>Select Sales Rep</option>
                    {salesreps.map((sales) => (
                      <option key={sales?._id} value={sales._id}>
                        {sales.firstName + ' ' + sales.lastName.substr(0, 1)}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className='text-left'>{customer?.salesrep?.name || "Unassigned"}</div>
                )}
              </div>
              <div className="flex-1 relative">
                <label htmlFor="csrrep" className="block text-left text-sm font-medium text-gray-700">
                  Csr Rep
                </label>
                {userInfo?.level === '9' ? (
                  <select
                    onChange={e => changecsr(e)}
                    value={customer?.csrrep?.id}
                    className="max-w-[80%] mt-3 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    disabled={disabled}
                  >
                    <option>Select CSR Rep</option>
                    {csrreps.map((csr) => (
                      <option key={csr?._id} value={csr._id}>
                        {csr.firstName + ' ' + csr.lastName.substr(0, 1)}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className='text-left'>{customer?.csrrep?.name || "Unassigned"}</div>
                )}
              </div>
              <div className="flex-1 relative">
                <label htmlFor="active" className="block text-left text-sm font-medium text-gray-700">
                  Active
                </label>
                {userInfo?.level !== '0' ? (
                  <select
                    onChange={e => setCustomer({ ...customer, active: e.target.value })}
                    value={customer?.active}
                    className="max-w-[80%] mt-3 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    disabled={disabled}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                ) : (
                  <div className='text-left'>{customer?.active === "true" ? 'Active' : "Inactive"}</div>
                )}
              </div>
            </div>
          )}
          <div className='flex relative mt-[25px]'>
            <div className="flex-1 relative">
              <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                User Name
              </label>
              <input
                onChange={e => setCustomer({ ...customer, name: e.target.value })}
                className="max-w-[80%] block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                value={customer?.name}
                type=""
              />
            </div>
            <div className="flex-2 relative">
              <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                className="max-w-[80%] block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                value={customer?.email}
                type=""
              />
            </div>
            <div className="flex-.5 relative">
              <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                Ext
              </label>
              <input
                className="max-w-[80%] block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                value={customer?.phone}
                type=""
              />
            </div>
            {customer?.level !== '0' && (
              <>
                <div className="flex-1 relative">
                  <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                    Access
                  </label>
                  <select
                    onChange={e => setCustomer({ ...customer, level: e.target.value })}
                    value={customer?.level}
                    className="max-w-[80%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    disabled={disabled}
                  >
                    <option value="9">Admin</option>
                    <option value="7">CSR</option>
                    <option value="8">Prepress</option>
                    <option value="6">Sales</option>
                  </select>
                </div>
                <div className="flex-1 relative">
                  <label htmlFor="active" className="block text-left text-sm font-medium text-gray-700">
                    Active
                  </label>
                  {userInfo?.level === '9' ? (
                    <select
                      onChange={e => setCustomer({ ...customer, active: e.target.value })}
                      value={customer?.active}
                      className="max-w-[80%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      disabled={disabled}
                    >
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                    </select>
                  ) : (
                    <div className='text-left'>{customer?.active === "true" ? 'Active' : "Inactive"}</div>
                  )}
                </div>
              </>
            )}
          </div>
          {customer?.level === '0' && (
            <div className='flex relative mt-[25px]'>
              <div className="flex-2 relative">
                <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                  Address
                </label>
                <input
                  className="max-w-[80%] block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  value={customer?.address}
                  type=""
                />
              </div>
              <div className="flex-2 relative">
                <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                  City
                </label>
                <input
                  className="max-w-[80%] block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  value=""
                  disabled
                  type=""
                />
              </div>
              <div className="flex-1 relative">
                <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                  State
                </label>
                <input
                  className="max-w-[80%] block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  value=""
                  disabled
                  type=""
                />
              </div>
              <div className="flex-1 relative">
                <label htmlFor="customerInput" className="block text-left text-sm font-medium text-gray-700">
                  Zip
                </label>
                <input
                  className="max-w-[80%] block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  value=""
                  disabled
                  type=""
                />
              </div>
            </div>
          )}
          <div className='flex relative mt-[45px] mb-[20px]'>
            <div className="flex-2 relative"></div>
            <div className="flex-1 relative"></div>
            <div className="flex-1 relative"></div>
            <div className="w-full flex relative gap-[30px]">
              <div className='w-[50%]'>
                <label htmlFor="customerInput" className="whitespace-nowrap block text-left text-sm font-medium text-gray-700">
                  Password Change
                </label>
                <input
                  className="max-w-[80%] block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              onChange={e => setNewpass(e.target.value)}
                  type="password"
                />
              </div>
              <div className='flex items-center'>
                <br />
                <button
                  className="whitespace-nowrap text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                  type="button"
                
                  onClick={e => changepassword()}
                >
                  Change Password
                </button>
              </div>
              <div className='flex-2'></div>
              <div className='flex items-center'>
                <button
                  className="whitespace-nowrap text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                  type="submit"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </form>
    </>
  );
};

export default EditCustomer;